var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},_vm._l((_vm.chats),function(chat){return _c('chatItem',{key:chat.cid,attrs:{"chat":chat},on:{"jump-to-chat":function($event){return _vm.$emit('jump-to-chat',chat.cid)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }